// extracted by mini-css-extract-plugin
export default {"root":"CoursePausePendingPage_root__qXQ+N"};